exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.backLinkBox___3vgt3 {\n  padding: 6px;\n}\n.overlayBox___2aE98 {\n  background-color: white;\n  flex: 100% 1 1;\n  justify-content: center;\n  left: 0;\n  min-height: 100%;\n  opacity: 0.95;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 2000;\n}\n.box___2GiGq {\n  position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"backLinkBox": "backLinkBox___3vgt3",
	"overlayBox": "overlayBox___2aE98",
	"box": "box___2GiGq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/FlowOverlay/styles.module.less
// module id = 1721
// module chunks = 70